import React, { useState, useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import {
  withStyles,
  Typography,
  Tooltip,
  Collapse,
  LinearProgress
} from '@material-ui/core'
import VerifiedUser from '@material-ui/icons/VerifiedUser'
import clsx from 'clsx'
import { Select, Snackbar } from 'elentari'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import IconButton from '@material-ui/core/IconButton'
import {
  CustomTextField,
  CustomDatePicker
} from '../../../components/CustomDisabledFields'
import { FieldArray } from 'react-final-form-arrays'
import { parseTelefone } from '../../../utils/Parse'
import VeiculoDenatranCard from '../Requisicoes/VeiculoDenatran/VeiculoDenatranCard'
import TransportadorAnttCard from '../Requisicoes/TransportadorAntt/TransportadorAnttCard'
import VeiculoDenatranRepository from '../Requisicoes/VeiculoDenatran/VeiculoDenatranRepository'
import veiculosRepository from './VeiculosRepository'
import { compareStrings } from '../../../utils/Compare'
import StatusLabel from '../../../components/StatusLabel'
import CustomFileViewer from '../../../components/CustomFileViewer'
import { path } from 'ramda'
import { validateCnpj, validateCpf } from '../../../utils/Validators'
import ViagensList from '../Viagens/ViagemList'
import InputAdornment from '@material-ui/core/InputAdornment'
import RefreshIcon from '@material-ui/icons/Refresh'
import ObservacaoField from '../../../components/ObservacaoField'
import EmpresaSelect from '../../Empresa/EmpresaSelect'
import PessoaJuridicaCard from '../Requisicoes/PessoaJuridica/PessoaJuridicaCard'
import DocumentValidator from '../../../components/DocumentValidator'
import PessoaFisicaCard from '../Requisicoes/PessoaFisica/PessoaFisicaCard'

const styles = theme => ({
  root: {
    padding: theme.spacing(6)
  },
  title: {
    marginBottom: theme.spacing(5)
  },
  validationField: {
    display: 'flex'
  },
  marginCorrection: {
    marginTop: theme.spacing(3)
  },
  importadoKMM: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2)
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  }
})

const fieldComparation = (fields, compare = compareStrings) =>
  fields
    .filter(a => !!a)
    .every((val, _, arr) => arr.length > 1 && compare(val, arr[0]))
    ? 'success'
    : 'error'

const allValid = values => values.filter(v => v.value !== 'success')

function VeiculoForm(props) {
  const {
    classes,
    fields,
    name,
    index,
    values,
    cannotUpdate,
    formChange,
    setMensagem,
    setFetching
  } = props
  const veiculo = fields.value[index]
  const proprietario = veiculo && veiculo.proprietario
  const proprietarioDoc = veiculo && veiculo.proprietarioDoc
  const viagens = proprietario && proprietario.viagens
  const viagensDoc = proprietarioDoc && proprietarioDoc.viagens
  const placa = veiculo && veiculo.placa

  const [expandedVeiculo, setExpandedVeiculo] = React.useState(false)
  const [expandedProprietario, setExpandedProprietario] = React.useState(false)
  const [expandedProprietarioDoc, setExpandedProprietarioDoc] = React.useState(
    false
  )
  const [veiculoDenatran, setVeiculoDenatran] = useState({})

  const handleExpandedVeiculoClick = () => {
    setExpandedVeiculo(!expandedVeiculo)
  }

  const handleExpandedProprietarioClick = () => {
    setExpandedProprietario(!expandedProprietario)
  }

  const handleExpandedProprietarioDocClick = () => {
    setExpandedProprietarioDoc(!expandedProprietarioDoc)
  }

  useEffect(() => {
    const fetchData = async () => {
      const solicitacaoId = props.match.params.id
      const [
        responseVeiculoDenatran,
      ] = await Promise.all([
        VeiculoDenatranRepository.list({
          query: { solicitacaoId, placa },
          paginate: { order: 'dataRequisicao DESC', limit: 1 }
        }),
      ])
      if (responseVeiculoDenatran.ok && !!responseVeiculoDenatran.data.length)
        setVeiculoDenatran(responseVeiculoDenatran.data[0])
    }
    fetchData()
  }, [props.match.params.id, placa])

  let validationChassi,
    validationAnoModelo,
    validationNomeProprietario,
    validationModelo,
    validationMarca,
    validationCor,
    validationUf,
    validationMunicipio

  let validDenatran = []

  if (veiculo) {
    validationChassi = fieldComparation([
      veiculoDenatran.chassi,
      veiculo.chassi
    ])
    validationMunicipio = fieldComparation([
      veiculoDenatran.descricaoMunicipioEmplacamento,
      veiculo.municipio
    ])
    validationAnoModelo = fieldComparation([
      veiculoDenatran.anoFabricacao,
      veiculo.ano
    ])

    if (veiculo.proprietarioDoc) {
      validationNomeProprietario = fieldComparation([
        veiculoDenatran.nomeProprietario,
        veiculo.proprietarioDoc.nomeRazaoSocial
      ])
    }

    validDenatran = allValid([
      { label: 'Chassi', value: validationChassi },
      { label: 'Ano/Modelo', value: validationAnoModelo },
      { label: 'Município', value: validationMunicipio },
      { label: 'Nome Proprietário', value: validationNomeProprietario }
    ])
  }
  const warningDenatranMessage = validDenatran.length
    ? `Campo(s) divergente(s): ${validDenatran.map(v => v.label).join(', ')}`
    : ''

  const handleChangePlacaConjunto = async () => {
    const placaFormated =
      values.veiculos && values.veiculos[0] && values.veiculos[0].placa
    if (placaFormated) {
      setFetching(true)
      setMensagem('Buscando veículos')
      const placa = placaFormated.replace(/[^a-zA-Z0-9]/g, '')
      const response = await veiculosRepository.findConjuntoKmmByPlacaForSolicitacao(
        props.match.params.id,
        placa
      )
      if (response.ok) {
        const veiculos = response.data.map((veiculo, index) => {
          veiculo.id = values.veiculos[index]
            ? values.veiculos[index].id
            : undefined
          veiculo.crlvImage = values.veiculos[index]
            ? values.veiculos[index].crlvImage
            : undefined
          veiculo.proprietario = {
            ...veiculo.proprietario,
            id: values.veiculos[index]?.proprietario?.id
          }
          veiculo.proprietarioDoc = {
            ...veiculo.proprietarioDoc,
            id: values.veiculos[index]?.proprietarioDoc?.id
          }
          return veiculo
        })
        formChange(`veiculos`, veiculos)
        setMensagem(
          'Veículo encontrado com sucesso! Alterações devem ser feitas no KMM.'
        )
      }
      setFetching(false)
    }
  }

  return (
    <Grid item xs={12}>
      <Grid container spacing={8}>
        {/* Half 0 - Form */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={8}>
            {/* Veiculo */}
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom>
                    {index + 1}° Veículo
                    {path(['veiculos', index, 'importadoKMM'], values) && (
                      <Tooltip title="Veículo importado KMM">
                        <VerifiedUser
                          color="disabled"
                          fontSize="small"
                          className={classes.importadoKMM}
                        />
                      </Tooltip>
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    disabled
                    label="Placa"
                    name={`${name}.placa`}
                    InputProps={
                      index === 0 && {
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              disabled={cannotUpdate}
                              onClick={handleChangePlacaConjunto}
                            >
                              <RefreshIcon />
                            </IconButton>
                          </InputAdornment>
                        )
                      }
                    }
                  />
                </Grid>
                <Grid item xs={12} md={8}>
                  <div className={classes.validationField}>
                    <Field
                      fullWidth
                      component={CustomTextField}
                      disabled
                      label="Tipo Carroceria"
                      name={`${name}.tipoCarroceria`}
                    />
                    <IconButton
                      className={clsx(classes.expand, {
                        [classes.expandOpen]: expandedVeiculo
                      })}
                      onClick={handleExpandedVeiculoClick}
                      aria-expanded={expandedVeiculo}
                      aria-label="show more"
                    >
                      <ExpandMoreIcon />
                    </IconButton>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <Collapse in={expandedVeiculo} timeout="auto" unmountOnExit>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={4}>
                        <Field
                          fullWidth
                          component={CustomTextField}
                          disabled
                          label="Renavam"
                          name={`${name}.renavam`}
                        />
                      </Grid>
                      <Grid item xs={12} md={8}>
                        <div className={classes.validationField}>
                          <Field
                            fullWidth
                            component={CustomTextField}
                            disabled
                            label="Chassi"
                            name={`${name}.chassi`}
                          />
                          <StatusLabel state={validationChassi} />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <div className={classes.validationField}>
                          <Field
                            fullWidth
                            component={CustomTextField}
                            disabled
                            label="Marca"
                            name={`${name}.marca`}
                          />
                          <StatusLabel state={validationMarca} />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <div className={classes.validationField}>
                          <Field
                            fullWidth
                            component={CustomTextField}
                            disabled
                            label="Modelo"
                            name={`${name}.modelo`}
                          />
                          <StatusLabel state={validationModelo} />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <div className={classes.validationField}>
                          <Field
                            fullWidth
                            component={CustomTextField}
                            disabled
                            label="Cor"
                            name={`${name}.cor`}
                          />
                          <StatusLabel state={validationCor} />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <div className={classes.validationField}>
                          <Field
                            fullWidth
                            component={CustomTextField}
                            disabled
                            label="Município"
                            name={`${name}.municipio`}
                          />
                          <StatusLabel state={validationMunicipio} />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <div className={classes.validationField}>
                          <Field
                            fullWidth
                            component={CustomTextField}
                            disabled
                            label="UF"
                            name={`${name}.uf`}
                          />
                          <StatusLabel state={validationUf} />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <div className={classes.validationField}>
                          <Field
                            fullWidth
                            component={CustomTextField}
                            disabled
                            label="Ano"
                            name={`${name}.ano`}
                          />
                          <StatusLabel state={validationAnoModelo} />
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <CustomFileViewer
                          label="CRLV"
                          filePath={veiculo.crlvImage}
                          newTab
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <DocumentValidator name={`${name}.crlvLegivel`} />
                      </Grid>
                    </Grid>
                  </Collapse>
                </Grid>
              </Grid>
            </Grid>
            {/* Proprietario ANTT */}
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom>
                    Proprietário ANTT
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    disabled
                    label="CPF/CNPJ"
                    name={`${name}.proprietario.cpfcnpj`}
                  />
                </Grid>
                <Grid item xs={12} md={8}>
                  <div className={classes.validationField}>
                    <Field
                      fullWidth
                      component={CustomTextField}
                      disabled
                      label="Nome/Razão Social"
                      name={`${name}.proprietario.nomeRazaoSocial`}
                    />
                    <IconButton
                      className={clsx(classes.expand, {
                        [classes.expandOpen]: expandedProprietario
                      })}
                      onClick={handleExpandedProprietarioClick}
                      aria-expanded={expandedProprietario}
                      aria-label="show more"
                    >
                      <ExpandMoreIcon />
                    </IconButton>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <Collapse
                    in={expandedProprietario}
                    timeout="auto"
                    unmountOnExit
                  >
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Field
                          fullWidth
                          component={CustomTextField}
                          disabled
                          label="Apelido/Nome Fantasia"
                          name={`${name}.proprietario.apelidoNomeFantasia`}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Field
                          fullWidth
                          component={CustomDatePicker}
                          disabled
                          label="Data de Nascimento"
                          name={`${name}.proprietario.dataNascimento`}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Field
                          fullWidth
                          component={CustomTextField}
                          disabled
                          label="Inscrição Estadual"
                          name={`${name}.proprietario.inscricaoEstadual`}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Field
                          fullWidth
                          component={CustomTextField}
                          disabled
                          label="PIS/PASEP"
                          name={`${name}.proprietario.pisPasep`}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Field
                          fullWidth
                          component={CustomTextField}
                          disabled
                          label="RNTRC TAC"
                          name={`${name}.proprietario.rntrcTac`}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Field
                          fullWidth
                          component={CustomDatePicker}
                          disabled
                          label="RNTRC Emissão"
                          name={`${name}.proprietario.rntrcEmissao`}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Field
                          fullWidth
                          component={CustomDatePicker}
                          disabled
                          label="RNTRC Validade"
                          name={`${name}.proprietario.rntrcValidade`}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom>
                          Viagens
                        </Typography>
                      </Grid>
                      {proprietario &&
                        (proprietario.quantidadeViagens ||
                          proprietario.destaquesViagens ||
                          proprietario.quantidadeUltimasViagens) && (
                          <Grid item xs={12}>
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={4}>
                                <Field
                                  fullWidth
                                  component={CustomTextField}
                                  disabled
                                  label="Quantidade G10"
                                  name={`${name}.proprietario.quantidadeViagens`}
                                />
                              </Grid>
                              <Grid item xs={12} sm={4}>
                                <Field
                                  fullWidth
                                  component={CustomTextField}
                                  disabled
                                  label="Destaques G10"
                                  name={`${name}.proprietario.destaquesViagens`}
                                />
                              </Grid>
                              <Grid item xs={12} sm={4}>
                                <Field
                                  fullWidth
                                  component={CustomTextField}
                                  disabled
                                  label="Quantidade Últimas G10"
                                  name={`${name}.proprietario.quantidadeUltimasViagens`}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                      {proprietario &&
                        (proprietario.quantidadeViagensTP ||
                          proprietario.destaquesViagensTP ||
                          proprietario.quantidadeUltimasViagensTP) && (
                          <Grid item xs={12}>
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={4}>
                                <Field
                                  fullWidth
                                  component={CustomTextField}
                                  disabled
                                  label="Quantidade TP"
                                  name={`${name}.proprietario.quantidadeViagensTP`}
                                />
                              </Grid>
                              <Grid item xs={12} sm={4}>
                                <Field
                                  fullWidth
                                  component={CustomTextField}
                                  disabled
                                  label="Destaques TP"
                                  name={`${name}.proprietario.destaquesViagensTP`}
                                />
                              </Grid>
                              <Grid item xs={12} sm={4}>
                                <Field
                                  fullWidth
                                  component={CustomTextField}
                                  disabled
                                  label="Quantidade Últimas TP"
                                  name={`${name}.proprietario.quantidadeUltimasViagensTP`}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                      <Grid item xs={12}>
                        <ViagensList viagens={viagens} />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom>
                          Sinistros
                        </Typography>
                      </Grid>
                      <FieldArray name={`${name}.proprietario.sinistros`}>
                        {({ fields }) =>
                          fields.length ? (
                            fields
                              .map((name, index) => (
                                <Grid key={name} item xs={12}>
                                  <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                      <Typography>
                                        {index + 1}º Sinistro
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <Field
                                        fullWidth
                                        component={CustomTextField}
                                        disabled
                                        label="Evento"
                                        name={`${name}.evento`}
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <EmpresaSelect
                                        disabled
                                        name={`${name}.empresaId`}
                                      />
                                    </Grid>
                                    <Grid item xs={12}>
                                      <Field
                                        fullWidth
                                        component={CustomTextField}
                                        disabled
                                        label="Ocorrência"
                                        multiline
                                        rows={5}
                                        name={`${name}.ocorrencia`}
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              ))
                              .filter((_, i) => i < 5)
                          ) : (
                            <Grid item xs={12}>
                              <Typography>
                                Não foram encontrados sinistros
                              </Typography>
                            </Grid>
                          )
                        }
                      </FieldArray>
                      <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom>
                          Contato
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Field
                          fullWidth
                          parse={parseTelefone}
                          component={CustomTextField}
                          disabled
                          label="Telefone"
                          name={`${name}.proprietario.telefone`}
                        />
                      </Grid>
                    </Grid>
                  </Collapse>
                </Grid>
              </Grid>
            </Grid>
            {/* Proprietario Documento */}
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom>
                    Proprietário Documento
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    disabled
                    label="CPF/CNPJ"
                    name={`${name}.proprietarioDoc.cpfcnpj`}
                  />
                </Grid>
                <Grid item xs={12} md={8}>
                  <div className={classes.validationField}>
                    <Field
                      fullWidth
                      component={CustomTextField}
                      disabled
                      label="Nome/Razão Social"
                      name={`${name}.proprietarioDoc.nomeRazaoSocial`}
                    />
                    <StatusLabel state={validationNomeProprietario} />
                    <IconButton
                      className={clsx(classes.expand, {
                        [classes.expandOpen]: expandedProprietarioDoc
                      })}
                      onClick={handleExpandedProprietarioDocClick}
                      aria-expanded={expandedProprietarioDoc}
                      aria-label="show more"
                    >
                      <ExpandMoreIcon />
                    </IconButton>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <Collapse
                    in={expandedProprietarioDoc}
                    timeout="auto"
                    unmountOnExit
                  >
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Field
                          fullWidth
                          component={CustomTextField}
                          disabled
                          label="Apelido/Nome Fantasia"
                          name={`${name}.proprietarioDoc.apelidoNomeFantasia`}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Field
                          fullWidth
                          component={CustomDatePicker}
                          disabled
                          label="Data de Nascimento"
                          name={`${name}.proprietarioDoc.dataNascimento`}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Field
                          fullWidth
                          component={CustomTextField}
                          disabled
                          label="Inscrição Estadual"
                          name={`${name}.proprietarioDoc.inscricaoEstadual`}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Field
                          fullWidth
                          component={CustomTextField}
                          disabled
                          label="PIS/PASEP"
                          name={`${name}.proprietarioDoc.pisPasep`}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Field
                          fullWidth
                          component={CustomTextField}
                          disabled
                          label="RNTRC TAC"
                          name={`${name}.proprietarioDoc.rntrcTac`}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Field
                          fullWidth
                          component={CustomDatePicker}
                          disabled
                          label="RNTRC Emissão"
                          name={`${name}.proprietarioDoc.rntrcEmissao`}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Field
                          fullWidth
                          component={CustomDatePicker}
                          disabled
                          label="RNTRC Validade"
                          name={`${name}.proprietarioDoc.rntrcValidade`}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom>
                          Viagens
                        </Typography>
                      </Grid>
                      {proprietarioDoc &&
                        (proprietarioDoc.quantidadeViagens ||
                          proprietarioDoc.destaquesViagens ||
                          proprietarioDoc.quantidadeUltimasViagens) && (
                          <Grid item xs={12}>
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={4}>
                                <Field
                                  fullWidth
                                  component={CustomTextField}
                                  disabled
                                  label="Quantidade G10"
                                  name={`${name}.proprietarioDoc.quantidadeViagens`}
                                />
                              </Grid>
                              <Grid item xs={12} sm={4}>
                                <Field
                                  fullWidth
                                  component={CustomTextField}
                                  disabled
                                  label="Destaques G10"
                                  name={`${name}.proprietarioDoc.destaquesViagens`}
                                />
                              </Grid>
                              <Grid item xs={12} sm={4}>
                                <Field
                                  fullWidth
                                  component={CustomTextField}
                                  disabled
                                  label="Quantidade Últimas G10"
                                  name={`${name}.proprietarioDoc.quantidadeUltimasViagens`}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                      {proprietarioDoc &&
                        (proprietarioDoc.quantidadeViagensTP ||
                          proprietarioDoc.destaquesViagensTP ||
                          proprietarioDoc.quantidadeUltimasViagensTP) && (
                          <Grid item xs={12}>
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={4}>
                                <Field
                                  fullWidth
                                  component={CustomTextField}
                                  disabled
                                  label="Quantidade TP"
                                  name={`${name}.proprietarioDoc.quantidadeViagensTP`}
                                />
                              </Grid>
                              <Grid item xs={12} sm={4}>
                                <Field
                                  fullWidth
                                  component={CustomTextField}
                                  disabled
                                  label="Destaques TP"
                                  name={`${name}.proprietarioDoc.destaquesViagensTP`}
                                />
                              </Grid>
                              <Grid item xs={12} sm={4}>
                                <Field
                                  fullWidth
                                  component={CustomTextField}
                                  disabled
                                  label="Quantidade Últimas TP"
                                  name={`${name}.proprietarioDoc.quantidadeUltimasViagensTP`}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                      <Grid item xs={12}>
                        <ViagensList viagens={viagensDoc} />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom>
                          Sinistros
                        </Typography>
                      </Grid>
                      <FieldArray name={`${name}.proprietarioDoc.sinistros`}>
                        {({ fields }) =>
                          fields.length ? (
                            fields
                              .map((name, index) => (
                                <Grid key={name} item xs={12}>
                                  <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                      <Typography>
                                        {index + 1}º Sinistro
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <Field
                                        fullWidth
                                        component={CustomTextField}
                                        disabled
                                        label="Evento"
                                        name={`${name}.evento`}
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <EmpresaSelect
                                        disabled
                                        name={`${name}.empresaId`}
                                      />
                                    </Grid>
                                    <Grid item xs={12}>
                                      <Field
                                        fullWidth
                                        component={CustomTextField}
                                        disabled
                                        label="Ocorrência"
                                        multiline
                                        rows={5}
                                        name={`${name}.ocorrencia`}
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              ))
                              .filter((_, i) => i < 5)
                          ) : (
                            <Grid item xs={12}>
                              <Typography>
                                Não foram encontrados sinistros
                              </Typography>
                            </Grid>
                          )
                        }
                      </FieldArray>
                      <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom>
                          Contato
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Field
                          fullWidth
                          parse={parseTelefone}
                          component={CustomTextField}
                          disabled
                          label="Telefone"
                          name={`${name}.proprietarioDoc.telefone`}
                        />
                      </Grid>
                    </Grid>
                  </Collapse>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* Half 1 - Cards de consultas */}
        <Grid item xs={12} md={6}>
          <VeiculoDenatranCard
            match={props.match}
            cpfcnpj={proprietarioDoc && proprietarioDoc.cpfcnpj}
            placa={veiculo && veiculo.placa}
            chassi={veiculo && veiculo.chassi}
            ano={veiculo && veiculo.ano}
            modelo={veiculo && veiculo.modelo}
            municipio={veiculo && veiculo.municipio}
            codRenavam={veiculo && veiculo.renavam}
            nomeProprietario={veiculo && veiculo.proprietarioDoc.nomeRazaoSocial}
            disabled={cannotUpdate}
            validData={validDenatran.length === 0}
            warningMessage={warningDenatranMessage}
            validateFieldName={`veiculos.${index}.denatranValida`}
          />
          <TransportadorAnttCard
            match={props.match}
            placa={veiculo && veiculo.placa}
            rntrc={proprietario && proprietario.rntrcTac}
            cpfcnpj={proprietario && proprietario.cpfcnpj}
            rntrcEmissao={proprietario && proprietario.rntrcEmissao}
            disabled={cannotUpdate}
            validateFieldName={`veiculos.${index}.anttValida`}
          />
          {veiculo &&
            veiculo.identificador === 0 &&
            validateCnpj(proprietario.cpfcnpj) && (
              <PessoaJuridicaCard
                match={props.match}
                cnpj={proprietario && proprietario.cpfcnpj}
                disabled={cannotUpdate}
                validateFieldName={`veiculos.${index}.pessoaJuridicaValida`}
              />
            )}
          {validateCpf(proprietario.cpfcnpj) && (
            <PessoaFisicaCard
              match={props.match}
              cpf={proprietario && proprietario.cpfcnpj}
              disabled={cannotUpdate}
              validateFieldName={`veiculos.${index}.pessoaFisicaValida`}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

function VeiculosForm(props) {
  const { classes, cannotUpdate, values } = props

  const [mensagem, setMensagem] = useState('')
  const [fetching, setFetching] = useState(false)

  return (
    <div className={classes.root}>
      {fetching && <LinearProgress />}
      <Grid container spacing={3}>
        {fetching && <LinearProgress />}
        <FieldArray name="veiculos">
          {({ fields }) => (
            <Grid container spacing={8}>
              {fields.map((name, index) => (
                <VeiculoForm
                  key={name}
                  {...props}
                  fields={fields}
                  name={name}
                  index={index}
                  setMensagem={setMensagem}
                  setFetching={setFetching}
                />
              ))}
              <Grid item xs={12} md={6}>
                <CustomFileViewer
                  newTab
                  label="Contrato Arrendamento"
                  filePath={values.contratoArrendamento}
                  fileType="pdf"
                />
              </Grid>
              {values.contratoArrendamento && (
                <Grid item xs={12}>
                  <DocumentValidator
                    disabled={cannotUpdate}
                    name="contratoValido"
                    legend="O contrato de arrendamento está correto?"
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <Typography variant="h6">Rastreador</Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <Field
                      fullWidth
                      hideEmpty
                      component={Select}
                      options={[
                        {
                          label: 'Telemonitoramento',
                          value: 'TELEMONITORAMENTO'
                        },
                        { label: 'Localizador', value: 'LOCALIZADOR' },
                        { label: 'Rastreador', value: 'RASTREADOR' }
                      ]}
                      label="Tipo de tecnologia"
                      name="tecnologia"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field
                      fullWidth
                      name="marcaTecnologia"
                      label="Marca/Modelo"
                      disabled={fetching || cannotUpdate}
                      component={CustomTextField}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6">Responsável pela frota</Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Field
                      fullWidth
                      component={CustomTextField}
                      label="Nome"
                      name="nomeResponsavelFrota"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Field
                      fullWidth
                      parse={parseTelefone}
                      component={CustomTextField}
                      label="Telefone"
                      name="telefoneResponsavelFrota"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Field
                      fullWidth
                      hideEmpty
                      component={Select}
                      options={[
                        { label: 'Sim', value: true },
                        { label: 'Não', value: false }
                      ]}
                      label="Contato com Proprietário Realizado"
                      name="contatoResponsavel"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Field
                      fullWidth
                      hideEmpty
                      component={Select}
                      options={[
                        { label: 'menos de 3 meses', value: 'MENOS_3MESES' },
                        { label: '3 meses a 1 ano', value: '3MESES_1ANO' },
                        { label: '1 a 2 anos', value: '1ANO_2ANOS' },
                        { label: 'mais de 2 anos', value: 'MAIS_2ANOS' }
                      ]}
                      label="Tempo do vínculo com Motorista"
                      name="tempoTrabalhoMotorista"
                    />
                  </Grid>
                  <ObservacaoField
                    value={values.observacaoContatoProprietario}
                    title="Observações Contato Responsável"
                    placeholder="Escreva aqui observações sobre as informações do contato com o responsável"
                    name="novaObservacaoContatoProprietario"
                    disabled={cannotUpdate}
                  />
                </Grid>
              </Grid>
              <ObservacaoField
                value={values.observacaoVeiculos}
                title="Observações Veículos"
                placeholder="Escreva aqui observações sobre as informações dos veículos"
                name="novaObservacaoVeiculos"
                disabled={cannotUpdate}
              />
            </Grid>
          )}
        </FieldArray>
      </Grid>
      <Snackbar message={mensagem} onClose={() => setMensagem('')} />
    </div>
  )
}

export default withStyles(styles)(VeiculosForm)
